'use client';

import { LiaMapMarkerAltSolid } from 'react-icons/lia';
import { Popover, Flex, Text, Anchor } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { SlArrowDown } from 'react-icons/sl';
import { SlArrowUp } from 'react-icons/sl';

export const LocationPopover = () => {
	const [opened, controls] = useDisclosure();

	return (
		<Popover position="bottom" opened={opened} onChange={controls.toggle}>
			<Popover.Target>
				<Anchor onClick={controls.toggle}>
					<Flex gap="sm">
						<LiaMapMarkerAltSolid size={22} />
						<Text>Tu jesteśmy</Text>
						{opened ? <SlArrowUp size={10} /> : <SlArrowDown size={10} />}
					</Flex>
				</Anchor>
			</Popover.Target>
			<Popover.Dropdown p="sm">
				<Text fw="bold">Dane firmy</Text>
				<Text fw="bold">Neopak Sp. z o.o.</Text>
				<Text>Wolica, al. Katowicka 60</Text>
				<Text mb="md">05-830 Nadarzyn</Text>

				<Anchor href="mailto:neopak@neopak.pl" fw="bold" c="red">
					neopak@neopak.pl
				</Anchor>
				<Text fw="bold">tel: +48 22 853 16 89, tel: +48 22 353 33 88</Text>
				<Text fw="bold">tel: +48 22 331 18 44, fax: + 48 22 266 87 84</Text>
			</Popover.Dropdown>
		</Popover>
	);
};
